import { useMemo } from 'react'
import cronstrue from 'cronstrue'
import { parseExpression } from 'cron-parser'

const getNextCronDates = (cronString: string, count: number): Date[] => {
  try {
    const interval = parseExpression(cronString)
    const dates: Date[] = []
    for (let i = 0; i < count; i++) {
      dates.push(interval.next().toDate())
    }
    return dates
  } catch (err) {
    console.error('Error parsing cron string:', err)
    return []
  }
}

export const parseCronString = (value: string | undefined): string | undefined => {
  try {
    cronstrue.toString(value ?? '') // Validates the cronString
    return value
  } catch {
    return undefined
  }
}

export const useCronSchedule = (
  value: string | undefined,
  nextDatesCount = 5,
  sumDaysCount = 30
): [string | undefined, Date[]] => {
  const cronString = parseCronString(value)
  const title = useMemo(() => (cronString ? cronstrue.toString(cronString) : '-'), [cronString])

  const nextDates = useMemo(
    () => (cronString ? getNextCronDates(cronString, nextDatesCount) : []),
    [cronString, nextDatesCount]
  )

  return [title, nextDates]
}
